import React from "react";
 import Range from "../../components/ReportFormGenerator/Range/Range";
import Date from "../../components/ReportFormGenerator/Date/Date";
import CropDown from "../../components/ReportFormGenerator/CropDown/CropDown";
import UniDropAdv from "../../components/ReportFormGenerator/UniDrop/UniDropAdv";  
import Idame from "../../components/ReportFormGenerator/Idame/Idame";
import Button from "../../components/ReportFormGenerator/Button/Button";
import { LoadingOutlined } from "@ant-design/icons";
import moment from "moment";
import {
  Form,
  Row,
  Col,
  Modal,
  Button as AntdButton,
  notification,
} from "antd";
import liracrypt from "../../components/Liracrypt/liracrypt";
import TextBox from "../../components/ReportFormGenerator/TextBox/TextBox";
import StablePrime from "../../components/Tables/StablePrime";

function ShiftSupervisorReport({ setPageHeader }) {
  setPageHeader("Shift Supervisor Report");
  const [form] = Form.useForm();
  const [apiName, setApiName] = React.useState(null);
  const [FormData, setFormData] = React.useState(null);
  const [response, setResponse] = React.useState(null);
  const [modalVisible, setModalVisible] = React.useState(false);
  const [load, setLoad] = React.useState(false);

  const [submitLoad, setSubmitLoad] = React.useState(false);

  const apiCall = (meth, value) => {
    if (meth === "GET") {
      setSubmitLoad(true);
      liracrypt
        .get("/shiftreport/supervisorreport", value)
        .then((res, req) => {
          setSubmitLoad(false);
          if (res.status === 200) {
            setResponse(res.data.data.rmrk);
          } else if (res.status === 204) {
            setModalVisible(true);
          }
        })
        .catch((err) => {
          setSubmitLoad(false);

          console.log(err);
        });
    } else if (meth === "POST") {
      setLoad(true);
      liracrypt
        .post("/shiftreport/supervisorreport", value)
        .then((res, req) => {
          setLoad(false);

          notification.success({
            message: res.data.message,
          });

          setResponse(null);
        })
        .catch((err) => {
          setLoad(false);
          console.log(err);
        });
    }
  };

  const onFinish = (values) => {
    setResponse(null);
    
    values["dt"] = moment(values["dt"]).format("YYYY/MM/DD").toString();
    // values["from"] = moment(values["range"][0]).format("YYYY/MM/DD").toString();
    // values["to"] = moment(values["range"][1]).format("YYYY/MM/DD").toString();
    // delete values["range"];
    setFormData(values);
    apiCall("GET", values);
    // setApiName("Demo01");
  };

  const DataTable = () => {
    return (
      <>
        {FormData ? (
          <StablePrime
            url="/stdtools/stabledata"
            data={FormData}
            identity="StableData"
          />
        ) : (
          <></>
        )}
      </>
    );
  };

  const onOk = () => {
    setResponse("");
    setModalVisible(false);
  };
  const onCancel = () => {
    setModalVisible(false);
  };

  return (
    <div>
      <Modal
        title="Shift Supervisor Report not available !"
        open={modalVisible}
        onOk={onOk}
        onCancel={onCancel}
        okText={
          <p style={{ fontWeight: 600 }}>
            {load ? <LoadingOutlined style={{ fontSize: 15 }} spin /> : "Yes"}
          </p>
        }
        cancelText={<p style={{ fontWeight: 600 }}>No</p>}
        cancelButtonProps={{ ghost: true, danger: true }}
        okButtonProps={{ ghost: true, loading: load }}
        centered
      >
        <p style={{ color: "#fff", fontSize: "15px", fontWeight: 600 }}>
          Do you want to create one ?
        </p>
      </Modal>

      {
        <Form
          name="ReportForm"
          form={form}
          labelCol={{ span: 8 }}
          wrapperCol={{ span: 16 }}
          onFinish={onFinish}
          layout="horizontal"
          colon={false}
          size="large"
        >
          <Row gutter={24} justify="center">
            <Col span={12}>
              <Date
                name="dt"
                label={"Date"}
                required={true}
                showTime={false}
                errorMessage={"Please Select  Date"}
                placeholder={"Select Date"}
                defaultValue={moment().format("YYYY-MM-DD")}
              />
            </Col>
          </Row>


          <Row gutter={24} justify="center">
            <Col span={12}>

            <UniDropAdv	
                form={form}
                colSpan={24}
                multiSelect={false}
                url={"/cropdown"}
                disabled={false}
                source={"cropdown"}
                urlData={{ name: "Shift" }}
                pname={"shift"}
                name={"sh"}
                label={"Shift"}
                errorMessage={"Please Select Shift !"}
                required={true}
                placeholder={"Select Shift"}
                defaultValue={""}
                searchable={true}
                includeAll={false}
              />

            </Col>
          </Row>

          <Row gutter={24} justify="center">
            {/* <Col span={12}> */}
            <Idame
              colSpan={12}
              form={form}
              type="name"
              url="/mdict"
              defaultIdValue="All"
              defaultNameValue="All"
              urlData={{
                typ: "Line",
                subTyp: "idame",
                includeAll: false,
              }}
              idName="lid"
              nameName="lame"
              nameLabel="Line"
              nameErrorMessage="Please Select Line"
              nameRequired={true}
              namePlaceholder="Select Line"
            />
            {/* </Col> */}
          </Row>

          {
            <Button
              marginLeft={"360px"}
              form={form}
              cancelButtonText={"Cancel"}
              submitButtonText={"Submit"}
              resetButton={true}
              loading={submitLoad}
            />
          }
        </Form>
      }
      <div
        style={{
          padding: "30px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "500px",
        }}
      >
        {response !== null ? (
          <>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                flex: 1,
              }}
            >
              <textarea
                type="text"
                style={{
                  width: "70%",
                  minHeight: "200px",
                  fontWeight: 600,
                  borderRadius: "10px",
                  fontSize: "18px",
                }}
                height="500px"
                value={response}
                onChange={(e) => setResponse(e.target.value)}
              ></textarea>
              <AntdButton
                type="primary"
                size={100}
                loading={load}
                style={{
                  fontWeight: "600",
                  marginTop: "10px",
                  borderRadius: "5px",
                }}
                onClick={() => {
                  apiCall("POST", { ...FormData, rmrk: response });
                }}
              >
                Submit
              </AntdButton>
            </div>
          </>
        ) : (
          //   <TextBox
          //     form={form}
          //     type="textArea"
          //     name={"in"}
          //     label={"Output"}
          //     // disabled={disabled}
          //     required={true}
          //     defaultValue={response}
          //     //   maxChar={400}
          //     //   maxCharErrorMessage="Accepted only 400 Chars"
          //   />
          <></>
        )}
      </div>
      {/* <DataTable /> */}
    </div>
  );
}

export default ShiftSupervisorReport;
